var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyimage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    fill: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1065_3082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0833 27.9167V50.0833H27.9167V27.9167H50.0833ZM50.0833 24.75H27.9167C26.175 24.75 24.75 26.175 24.75 27.9167V50.0833C24.75 51.825 26.175 53.25 27.9167 53.25H50.0833C51.825 53.25 53.25 51.825 53.25 50.0833V27.9167C53.25 26.175 51.825 24.75 50.0833 24.75ZM42.3883 38.7783L37.6383 44.9058L34.25 40.805L29.5 46.9167H48.5L42.3883 38.7783Z",
    fill: "#727272"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1065_3082"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyimage);
export default __webpack_public_path__ + "static/media/emptyimage.67bb1428916bf7d75f395774bedadfd0.svg";
export { ForwardRef as ReactComponent };